'use client';

import { SubscribePayPal } from './SubscribePayPal';
import { SubscribeStripe } from './SubscribeStripe';

type PaymentProvider = 'Stripe' | 'Paypal' | 'none';

type Props = {
  paymentProvider: PaymentProvider;
  creatorId: number;
  userId: number;
  profileUniqueLink: string;
  creatorName?: string;
  price?: number;
  isAnonymous?: boolean;
  className?: string;
  isSubscribe?: boolean;
  setIsSubscribe?: (v: boolean) => void;
  isOpenedFromDialog?: boolean;
  isMyProfile: boolean;
  subscribedInfo?: any;
  isGoal?: boolean;
  stripeAccount?: string;
  tierKey?: string;
  paypalStatus?: any;
  isCreatorPartner: boolean;
};

export function Subscribe(props: Props) {
  if (props.paymentProvider === 'Stripe') {
    return <SubscribeStripe {...props} />;
  }

  if (props.paymentProvider === 'Paypal') {
    return (
      <SubscribePayPal
        {...props}
        tierKey={props.tierKey || ''}
        creatorName={props.creatorName || ''}
      />
    );
  }

  return null;
}
